import { atom, PrimitiveAtom } from 'jotai'
import { atomFamily } from 'jotai/utils'

import {
  MODAL_TYPES,
  ModalCallbacks,
  ModalProps,
  ModalType,
} from '../typings/Modals'

export const activeModalsFamily = atomFamily<ModalType, PrimitiveAtom<boolean>>(
  (modalType) => atom(false),
)

export const modalPropsFamily = atomFamily<
  ModalType,
  PrimitiveAtom<ModalProps[ModalType] | undefined>
>((modalType) => atom<ModalProps[typeof modalType] | undefined>(undefined))

export const modalCallbacksFamily = atomFamily<
  ModalType,
  PrimitiveAtom<ModalCallbacks[ModalType] | undefined>
>((modalType) => atom<ModalCallbacks[typeof modalType] | undefined>(undefined))

export const openModalAtom = atom<
  null,
  [ModalType, ModalProps[ModalType]?, ModalCallbacks[ModalType]?],
  void
>(null, (_get, set, modalType, props, callbacks) => {
  set(activeModalsFamily(modalType), true)
  set(modalPropsFamily(modalType), props)
  set(modalCallbacksFamily(modalType), callbacks)
})

export const closeModalAtom = atom<null, [ModalType], void>(
  null,
  (_, set, modalType) => {
    set(activeModalsFamily(modalType), false)
    set(modalPropsFamily(modalType), undefined)
    set(modalCallbacksFamily(modalType), undefined)
  },
)

export const hasActiveModalAtom = atom((get) => {
  return MODAL_TYPES.some((type) => get(activeModalsFamily(type)))
})

export const activeModalAtom = atom((get) => {
  return MODAL_TYPES.find((type) => get(activeModalsFamily(type)))
})
